/**
 * @generated SignedSource<<1ec18c53afe10dc76d556d2bff763c3b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type Platform = "META" | "%future added value";
export type GetPreSignedUrlRequest = {
  adId: string;
  extension: string;
  platform: Platform;
};
export type CreativeDrawerGetPreSignedUrlMutation$variables = {
  input: GetPreSignedUrlRequest;
};
export type CreativeDrawerGetPreSignedUrlMutation$data = {
  readonly getPreSignedUrl: string;
};
export type CreativeDrawerGetPreSignedUrlMutation = {
  response: CreativeDrawerGetPreSignedUrlMutation$data;
  variables: CreativeDrawerGetPreSignedUrlMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "getPreSignedUrl",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreativeDrawerGetPreSignedUrlMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreativeDrawerGetPreSignedUrlMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b76613d1dd3c12159c6c323aded52465",
    "id": null,
    "metadata": {},
    "name": "CreativeDrawerGetPreSignedUrlMutation",
    "operationKind": "mutation",
    "text": "mutation CreativeDrawerGetPreSignedUrlMutation(\n  $input: GetPreSignedUrlRequest!\n) {\n  getPreSignedUrl(input: $input)\n}\n"
  }
};
})();

(node as any).hash = "3c97f7e337a81a43e6c70ca759d9b5e3";

export default node;
